import { useState, useEffect } from 'react';

/**
 * Custom hook for countdown timer
 * @param {string} expiryDate - ISO date string
 * @returns {object} - { d, h, m, s, expired, formatted }
 */
export function useCountdown(expiryDate) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!expiryDate) return;

    function update() {
      const now = new Date();
      const target = new Date(expiryDate);
      const diff = target - now;

      if (diff <= 0) {
        setTimeLeft({ expired: true, d: 0, h: 0, m: 0, s: 0 });
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      // Format based on time remaining
      let formatted = '';
      if (d > 0) {
        formatted = `${d}d ${h.toString().padStart(2, '0')}h ${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
      } else if (h > 0) {
        formatted = `${h.toString().padStart(2, '0')}h ${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
      } else if (m > 0) {
        formatted = `${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
      } else {
        formatted = `${s}s`;
      }

      setTimeLeft({ d, h, m, s, expired: false, formatted });
    }

    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [expiryDate]);

  return timeLeft;
}
